/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Cutoff_DescInputs */



/**
* | output |
* | --- |
* | "hidden, shows top-5 threshold" |
*
* @param {Og_Cfg_Cutoff_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_cutoff_desc = /** @type {((inputs?: Og_Cfg_Cutoff_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Cutoff_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("masqué, affiche le seuil du top 5")
	if (locale === "es") return /** @type {LocalizedString} */ ("oculta, muestra el umbral del top 5")
	if (locale === "pt") return /** @type {LocalizedString} */ ("oculta, mostra o limite para o top 5")
	if (locale === "it") return /** @type {LocalizedString} */ ("nascosta, mostra la soglia del top 5")
	return /** @type {LocalizedString} */ ("hidden, shows top-5 threshold")
});